import { useMemo } from 'react';
import { useGetMemberTeamResultsByFormatQuery } from '../state/api';
import MemberTeamFormatSummary from './member-team-format-summary';
import { processFormatStats, calculateFormatTotals } from './member-stats.utils';

interface MemberTeamFormatSummaryContainerProps {
  member_id: string | undefined;
}

const MemberTeamFormatSummaryContainer = ({ member_id }: MemberTeamFormatSummaryContainerProps) => {
  const { data: formatSummary = [] } = useGetMemberTeamResultsByFormatQuery(member_id!, {
    skip: member_id === undefined,
  });

  const formatStats = useMemo(() => processFormatStats(formatSummary), [formatSummary]);
  const formatTotals = useMemo(() => calculateFormatTotals(formatSummary), [formatSummary]);

  return <MemberTeamFormatSummary formatStats={formatStats} formatTotals={formatTotals} />;
};

export default MemberTeamFormatSummaryContainer;
